export default __webpack_public_path__ + "static/shopify-plus-partner-logo-white-c026c3f2039fea51165de5357bf48ee4.png";